import { Directive, Input, OnChanges, ElementRef } from '@angular/core';

@Directive({ selector: '[ng-indeterminate]' })

export class NgIndeterminateDirective implements OnChanges {

    @Input('ng-indeterminate') private indeterminate: boolean;

    constructor(private elementRef: ElementRef) {
    }

    public ngOnChanges(changes: any) {
        this.elementRef.nativeElement.indeterminate = changes.indeterminate.currentValue;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/directives/ng-indeterminate/ng-indeterminate.directive.ts